import { useLayoutEffect, useRef } from 'react';
import type { NodeId } from '@vellum/core';
import { app } from '../app.ts';
import { useApp } from '../hooks.ts';
import { titleRect } from './overlay.ts';

/** Renames a frame or section where its title is drawn on the canvas (double-click the title, or ⌘R). */
export function TitleRename({ id }: { id: NodeId }) {
  const ref = useRef<HTMLInputElement>(null);
  const done = useRef(false);
  const node = useApp(['doc', 'camera'], () => app.doc.get(id));
  const rect = node ? titleRect(app, node) : null;
  useLayoutEffect(() => {
    ref.current?.focus();
    ref.current?.select();
  }, []);
  if (!node || !rect) return null;
  const finish = (save: boolean) => {
    if (done.current) return;
    done.current = true;
    const name = ref.current?.value.trim() ?? '';
    if (save && name && name !== node.name) app.editor.update(id, { name }, 'Rename');
    app.setUI({ renaming: null });
  };
  const section = node.type === 'SECTION';
  return (
    <input
      ref={ref}
      className={`title-rename${section ? ' section' : ''}`}
      defaultValue={node.name}
      spellCheck={false}
      style={{ left: rect.x - (section ? 0 : 3), top: rect.y - (section ? 0 : 1), minWidth: Math.max(rect.width + 24, 80) }}
      onBlur={() => finish(true)}
      onPointerDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === 'Enter') finish(true);
        if (e.key === 'Escape') finish(false);
      }}
    />
  );
}
